var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_47144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.75V14.25C6.75 13.6533 6.98705 13.081 7.40901 12.659C7.83097 12.2371 8.40326 12 9 12H15.75C16.3467 12 16.919 11.7629 17.341 11.341C17.7629 10.919 18 10.3467 18 9.75V8.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25V15.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25C7.99264 8.25 9 7.24264 9 6C9 4.75736 7.99264 3.75 6.75 3.75C5.50736 3.75 4.5 4.75736 4.5 6C4.5 7.24264 5.50736 8.25 6.75 8.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.25C19.2426 8.25 20.25 7.24264 20.25 6C20.25 4.75736 19.2426 3.75 18 3.75C16.7574 3.75 15.75 4.75736 15.75 6C15.75 7.24264 16.7574 8.25 18 8.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 20.25C7.99264 20.25 9 19.2426 9 18C9 16.7574 7.99264 15.75 6.75 15.75C5.50736 15.75 4.5 16.7574 4.5 18C4.5 19.2426 5.50736 20.25 6.75 20.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_47144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--bg-surface)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBranch);
export default __webpack_public_path__ + "static/media/sidebarBranch.7f53c158a8cf67d4cb2b391672cfafcc.svg";
export { ForwardRef as ReactComponent };